(() => {
  document.addEventListener('audio-control-init', (e) => {
    var $section = e.target.closest('.video-parent-section');
    if (!$section) return;

    $section.addEventListener('click', function(e) {
      var video_type = $section.querySelector('.video-div').dataset.type;
      var player_id = $section.querySelector('.video-div').getAttribute('id');
      
      if (video_type == 'youtube') {
        var player = YT.get(player_id);
        //console.log(player_id, player);
        player[player.isMuted() ? 'unMute' : 'mute']();
      }
      
      else if (video_type == 'vimeo') {
        var player = new Vimeo.Player(document.querySelector('.video-div iframe'));
        //console.log(player);
        player.getMuted().then(function(muted) {
          player.setVolume(muted ? 1 : 0);
        });
      }

      else if (video_type == 'mp4') {
        var $video = $section.querySelector('video');
        $video.muted = !$video.muted;
      }
    });
  });

  document.addEventListener('alpine:init', () => {
    Alpine.data('CollectionTiles', () => ({
      $section: null,
      $tiles: null,
      init() {
        let am = this;
        document.addEventListener('init-CollectionTiles', (e) => {
          if (am.$section) return;
          am.$section = e.target;

          am.$tiles = am.$section.querySelectorAll('.grid-tile');
          am.MoveTilesToCollection();
        });
      },
      MoveTilesToCollection() {
        let am = this;
        let $collection = document.querySelector('.collection-grid');
        if (!$collection) return;

        am.$tiles.forEach(($tile) => {
          $collection.insertAdjacentElement('beforeend', $tile);
        });
      }
    }));

    Alpine.data('CountdownTimer', () => ({
      $section: null,
      countdownText: '',
      countdown_t: null,
      init() {
        let am = this;
        document.addEventListener('init-CountdownTimer', (e) => {
          if (am.$section) return;
          am.$section = e.target;
          am.UpdateCountdown();
        });
      },
      UpdateCountdown() {
        let am = this;
        if (!am.$section) return;
        let countdown_date = am.$section.dataset.countdown;
        clearInterval(am.countdown_t);
        am.countdown_t = setInterval(() => {
          am.countdownText = UTILS.GetCountdown(countdown_date);
        }, 1000); // Update every second
      }
    }));

    const MAX_QTY = 10;
    Alpine.data('PDPQuantity', () => ({
      variants: [],
      max: MAX_QTY,
      qty: 1,
      selected_variant: null,
      init() {
        this.variants = JSON.parse(this.$el.dataset.variants);
        this.$el.removeAttribute('data-variants');
        this.UpdateSelectedVariant();
        this.InitWatchers();
      },
      InitWatchers() {
        let am = this;
        am.$el.closest('.product-section').addEventListener('variantChange', (e) => {
          // console.log(e);
          am.$el.dataset.current_variant_id = e.detail.variant.id;
          am.UpdateSelectedVariant();
        });

        am.$el.querySelector('input').addEventListener('input', (e) => {
          // console.log(e);
          let qty = parseInt(e.target.value);
          am.qty = qty > MAX_QTY ? MAX_QTY : qty;
        });
        am.$el.addEventListener('click', (e) => {
          // console.log(e);
          let qty = parseInt(this.$el.querySelector('input').value);
          am.qty = qty > MAX_QTY ? MAX_QTY : qty;
        });
      },
      UpdateSelectedVariant() {
        this.selected_variant = this.variants.find(v => v.id == this.$el.dataset.current_variant_id);
        let variant_max_qty = this.selected_variant.inventory_quantity;
        this.max = variant_max_qty > MAX_QTY ? MAX_QTY : variant_max_qty;
      }
    }));

    Alpine.data('CartItemQuantity', (qty) => ({
      qty: qty,
      max: MAX_QTY,
      e_CheckMaxQty(e) {
        let qty = parseInt(e.target.value);
        this.qty = qty > this.max ? this.max : qty;
        e.target.value = this.qty;
      }
    }));
  });
})();


document.addEventListener(('DOMContentLoaded'), () =>{
  let spaceFinder = setInterval((function(){
    if(encodeURIComponent(document.body.firstChild.textContent) === "%E2%80%8B%0A"){
      document.body.firstChild.remove();
      stopSearchingNode();
    }
  }), 100);

  function stopSearchingNode(){
    clearInterval(spaceFinder);
  }
})


document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
      <div class="product-card__images">
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${(event) => handleItemClick(event, item)}"
    >
      <div class="aa-ItemContent ">
        <div class="aa-ItemPicture aa-ItemPicture--loaded product-card grid-product__has-quick-shop has-hover-image">
          <img
            src="${algoliaShopify.helpers.largeImage(item)}"
            alt="${item.title}"
            class="product__background-image product__background-image--first lazyloaded"
            style="max-height: none;"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
  `;
    }
  );
});


